import React, { FC } from 'react';
import { ChannelImageInnerWrapper, ChannelLogoWrapper } from 'style/styled-components/reusable.css';
import { Picture } from 'components/Picture/Picture';

type PropTypes = {
    src?: string;
    channelName?: string;
};

export const CardChannelLogo: FC<PropTypes> = ({ src, channelName }) => {
    if (!src) {
        return null;
    }

    return (
        <ChannelLogoWrapper>
            <ChannelImageInnerWrapper>
                <Picture src={src} alt={channelName} hPosition={'right'} vPosition={'center'} fit={'scale-down'} />
            </ChannelImageInnerWrapper>
        </ChannelLogoWrapper>
    );
};
